"use client";

import type { CurrencyType } from "@workspace/currency";
import { BalanceDisplay } from "@workspace/frontend-ui";
import { useSelectedLayoutSegments } from "next/navigation";
import type { FC } from "react";
import isGamePageRoute from "../isGamePageRoute";
import isOriginalGameRoute from "../isOriginalGameRoute";
import useGameBalance from "./useGameBalance";

type Props = {
  currency: string;
  cashierBalance: number;
  type?: CurrencyType | null;
  maximumFractionDigits?: number | null;
  syncedAt?: number;
  playingPhrase?: string;
  isUbtcEnabled?: boolean;
  originalGameHandles?: string[];
};

const Balance: FC<Props> = ({
  currency,
  cashierBalance,
  type,
  maximumFractionDigits,
  syncedAt,
  playingPhrase,
  isUbtcEnabled,
  originalGameHandles,
}) => {
  const routes = useSelectedLayoutSegments();
  const balance = useGameBalance(cashierBalance, syncedAt);
  const isPlaying =
    isGamePageRoute(routes) &&
    !isOriginalGameRoute(routes, originalGameHandles);

  return (
    <BalanceDisplay
      currency={currency}
      cashierBalance={balance}
      type={type}
      maximumFractionDigits={maximumFractionDigits}
      isPlaying={isPlaying}
      playingPhrase={playingPhrase}
      isUbtcEnabled={isUbtcEnabled}
    />
  );
};

export default Balance;
